import React from 'react';
import { Row, Col, Paper, BackButton, PartnerDataForm } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var AddPartner = function AddPartner(_ref) {
  var history = _ref.history;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    backgroundColor: "white",
    padding: "2em",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: "auto",
    position: "relative",
    margin: "0 0 1.4em"
  }, ___EmotionJSX(BackButton, {
    onBack: function onBack() {
      return history.push('/partner');
    }
  }))), ___EmotionJSX(Row, {
    backgroundColor: "white",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440"
  }, ___EmotionJSX(PartnerDataForm, {
    onSubmit: function onSubmit() {
      return history.push('/partner');
    }
  })))));
};

export default AddPartner;